import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { LeaveImportTemplate } from 'app/modules/common/entities/leave-import/template.model';
import API from '../../common/services/api.config.json';
import { map, tap } from 'rxjs/operators';
import { LeaveImportModel } from 'app/modules/common/entities/leave-import/leave-import.model';
import { LeaveImportResult } from 'app/modules/common/types/leave-import-results.type';

export type TemplateList = Record<number, string>;

export interface TaskCriteria {
    CriterioId: number;
    Nombre: string;
}


@Injectable({
    providedIn: 'root'
})
export class LeaveImportService {

    private _templatesList = new BehaviorSubject<TemplateList>([]);
    /**
     * Subscribe to templates list. If this service is properly used, every change in templates list will be notified from
     * this `subject`
     */
    public get templatesList(): BehaviorSubject<TemplateList> {
        return this._templatesList;
    }


    constructor(
        private apiService: ApiService,
    ) {
        // update templates list
        this.updateTemplatesList();
    }


    /**
     * Import leaves using an Excel file 🙂🙃
     * @param data Leave import data
     */
    public importLeaves(data: LeaveImportModel): Observable<RestResponse<LeaveImportResult>> {
        const url = API.LeaveImport.importLeaves as string;
        return this.apiService.post(url, data);
    }



    //#region TEMPLATE

    /**
     * Create leave import template
     */
    public createTemplate(template: LeaveImportTemplate): Observable<RestResponse<LeaveImportTemplate>> {
        const url = API.LeaveImport.templatesEndPoint;
        return this.apiService
            .post(url, template)
            .pipe(
                tap(() => this.updateTemplatesList())
            );
    }


    /**
     * Update templates list subscriber
     */
    public updateTemplatesList() {
        const url = API.LeaveImport.getTemplatesNames;
        this.apiService
            .get(url)
            .pipe(
                map(res => {
                    if (res.code === 0)
                        return res.result as TemplateList;
                    else
                        throw new Error(res.message ?? res);
                })
            )
            .subscribe((templatesList) => this._templatesList.next(templatesList));
    }


    /**
     * Get template by ID
     */
    public getTemplate(id: number): Observable<RestResponse<LeaveImportTemplate>> {
        const url = `${API.LeaveImport.templatesEndPoint}/${id}`;
        return this.apiService.get(url);
    }


    /**
     * Delete template
     */
    public deleteTemplate(id: number): Observable<RestResponse<null>> {
        const url = `${API.LeaveImport.templatesEndPoint}/${id}`;
        return this.apiService
            .delete(url)
            .pipe(
                tap(() => this.updateTemplatesList())
            );
    }

    //#endregion

}
